import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export default function DatePickerIta(props) {
    const [value, setValue] = React.useState(props.startValue ? dayjs(props.startValue, 'DD/MM/YYYY') : null);

    const handleChange = (newValue) => {
        setValue(newValue);
        props.onValueChange(newValue.format('DD/MM/YYYY'));
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker disablePast={props.disablePast} readOnly={props.readOnly} value={value} format='DD/MM/YYYY' closeOnSelect sx={{ border: props.redBorder ? "1px solid red" : "none", borderRadius: '5px', flexGrow: props.grow ? 1 : 0 }} label={props.label} onChange={handleChange} />
        </LocalizationProvider>
    );
}   